<template>
  <div class="banner">
    <b-row>
      <b-col cols="4">
        <p class="text-header">Theme Setting</p>
      </b-col>
    </b-row>
    <div class="bg-white p-3 tw-min-h-screen">
      <b-row class="my-3">
        <b-col cols="4">
          <label>Home page logo</label>
          <UploadImageAndPreview2
            v-model="form.themeLogoHomePage"
            :value="form.themeLogoHomePage"
            className="image-upload-preview-box"
            @deleteImage="deleteImage"
            name="themeLogoHomePage"
            desc="Dimension 345x159 px not over 1 MB (Please attach file .jpg only)"
            @handleImageUpload="handleImageUpload"
          />
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col cols="4">
          <label>Nav bar icon</label>
          <UploadImageAndPreview2
            v-model="form.themeNavIcon"
            :value="form.themeNavIcon"
            className="image-upload-preview-box"
            @deleteImage="deleteThemeNavIcon"
            name="themeNavIcon"
            desc="Dimension 345x159 px not over 1 MB (Please attach file .jpg only)"
            @handleImageUpload="handleThemeNavIcon"
          />
        </b-col>
      </b-row>

      <b-row class="my-3">
        <b-col cols="6">
          <UploadFileV2
            textFloat="Font"
            placeholder="Please Upload Font"
            class="w-100"
            format="font"
            name="Font-bold"
            v-on:onFileChange="onFileChange"
            v-on:delete="deleteFile"
            :fileName="form.themeFontUrl"
            v-model="form.themeFontUrl"
            :value="form.themeFontUrl"
            id="uploadfile2"
            :isValidType="false"
            text=""
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Bar Layout Type</label>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="form.themeLayoutBarId"
              :options="optionLayout"
              :aria-describedby="ariaDescribedby"
              name="radios-type"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" lg="5">
          <b-row>
            <b-col>
              <ColorPicker
                textFloat="Primary Color"
                v-model="form.themePrimaryColor"
                :value="form.themePrimaryColor"
                name="primary_color"
              />
            </b-col>
            <b-col>
              <ColorPicker
                textFloat="Light Primary Color"
                v-model="form.themeLightPrimaryColor"
                :value="form.themeLightPrimaryColor"
                name="light_primary_color"
              />
            </b-col>
          </b-row>
          <b-row class="my-3">
            <b-col>
              <ColorPicker
                textFloat="Secondary Color"
                v-model="form.themeSecondaryColor"
                :value="form.themeSecondaryColor"
                name="secondary_color"
              />
            </b-col>
            <b-col>
              <ColorPicker
                textFloat="Disabled Color"
                v-model="form.themeDisableColor"
                :value="form.themeDisableColor"
                name="themeDisableColor"
              />
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col>
              <ColorPicker
                textFloat="Background Color"
                v-model="form.themeBackgroundColor"
                :value="form.themeBackgroundColor"
                name="themeBackgroundColor"
              />
            </b-col>
            <b-col>
              <ColorPicker
                textFloat="Button Color"
                v-model="form.themeButtonColor"
                :value="form.themeButtonColor"
                name="themeButtonColor"
              />
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col>
              <ColorPicker
                textFloat="Bar Color"
                v-model="form.themeBarColor"
                :value="form.themeBarColor"
                name="themeBarColor"
              />
            </b-col>
            <b-col>
              <ColorPicker
                textFloat="Font Color"
                v-model="form.themeFontColor"
                :value="form.themeFontColor"
                name="themeFontColor"
              />
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col cols="6">
              <ColorPicker
                textFloat="Bottom Bar Color"
                v-model="form.themeBottomBarColor"
                :value="form.themeBottomBarColor"
                name="themeBottomBarColor"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" lg="4">
          <div
            class="front-preview-box"
            :style="{ color: form.themeFontColor }"
          >
            <div
              class="navbar"
              :style="{ backgroundColor: form.themeBarColor }"
            >
              <img :src="form.themeLogoHomePage" alt="themeLogoHomePage" />
            </div>
            <div class="content">
              <div class="title">บริการ</div>
              <div>
                <div class="card">
                  <div class="image"></div>
                  <div class="card-content">
                    <div class="card-content-title">ชื่อบริการ</div>
                    <div class="card-content-info">
                      <div class="info">
                        <font-awesome-icon :icon="['far', 'address-card']" />
                        <div>ชื่อสาขา</div>
                      </div>
                      <div class="info">
                        <font-awesome-icon :icon="['far', 'address-card']" />
                        <div>รายการทั้งหมด</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="bottom-bar"
              :style="{
                color: form.themePrimaryColor,
                backgroundColor: form.themeBottomBarColor,
              }"
            >
              <div
                class="bottom-bar bottom-bar-1"
                v-if="form.themeLayoutBarId === '1'"
              >
                <div class="icon">
                  <font-awesome-icon :icon="['far', 'address-card']" />
                </div>
                <div class="icon active">
                  <font-awesome-icon :icon="['fas', 'calendar']" />
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'history']" />
                </div>
              </div>
              <div
                class="bottom-bar bottom-bar-1"
                v-if="form.themeLayoutBarId === '2'"
              >
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'clock']" />
                  <div>My Booking</div>
                </div>
                <div class="icon active">
                  <font-awesome-icon :icon="['fas', 'calendar-alt']" />
                  <div>Services</div>
                </div>
                <div class="icon">
                  <font-awesome-icon :icon="['fas', 'address-card']" />
                  <div>My Profile</div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      class="tw-sticky tw-bottom-0 tw-bg-white tw-z-40 tw-w-full tw-h-12 tw-px-3"
    >
      <div class="footer">
        <b-button
          class="btn-filter btn submit"
          :disabled="isLoading"
          @click="onClickSave"
        >
          <div class="d-flex align-items-center justify-content-center">
            บันทึก

            <b-spinner
              label="Spinning"
              class="ml-1"
              small
              v-if="isLoading"
            ></b-spinner>
          </div>
        </b-button>
      </div>
    </div>

    <ModalAlertText :textModal="textModal" :arrModal="[]" :size="sizeModal" />
  </div>
</template>

<script>
import ColorPicker from "@/components/inputs/InputColorPicker";
import UploadImageAndPreview2 from "@/components/inputs/UploadImageAndPreview2";
import UploadFileV2 from "@/components/inputs/UploadFileV2";
import ModalAlertText from "@/components/modal/ModalAlertText.vue";
export default {
  name: "SettingPage",
  components: {
    ColorPicker,
    UploadImageAndPreview2,
    UploadFileV2,
    ModalAlertText,
  },
  data() {
    return {
      sizeModal: "md",
      form: {
        themeLogoHomePage: "",
        themePrimaryColor: "#ffffff",
        themeLightPrimaryColor: "#ffffff",
        themeSecondaryColor: "#ffffff",
        themeDisableColor: "#ffffff",
        themeBackgroundColor: "#ffffff",
        themeButtonColor: "#ffffff",
        themeBarColor: "#ffffff",
        themeFontColor: "#ffffff",
        themeBottomBarColor: "#ffffff",
        themeLayoutBarId: "1",
        themeFontUrl: "",
        themeNavIcon: "",
      },
      isLoading: false,

      // state modal
      textModal: "",
      arrStatus: [],

      optionLayout: [
        {
          value: "1",
          text: "แบบที่ 1",
        },
        {
          value: "2",
          text: "แบบที่ 2",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getThemeSetting();
  },
  methods: {
    async getThemeSetting() {
      const respone = await this.$services.master.getThemeSetting();
      if (respone.result === 1) {
        this.form = respone.detail;
      }
    },
    async onClickSave() {
      this.$EventBus.$emit("showLoading");
      const res = await this.$services.master.saveThemeSetting(this.form);
      this.openModalAlertText(res.message);
      this.$EventBus.$emit("hideLoading");
    },
    openModalAlertText(text) {
      this.textModal = text;
      this.$bvModal.show("modal-alert-text");
    },
    async handleImageUpload(val) {
      this.$EventBus.$emit("showLoading");
      const getData = await this.$services.master.UploadLogo({
        Base64String: val,
      });
      this.form.themeLogoHomePage = getData.url;
      this.$EventBus.$emit("hideLoading");
    },
    deleteImage() {
      this.form.themeLogoHomePage = "";
    },
    async handleThemeNavIcon(val) {
      this.$EventBus.$emit("showLoading");
      const getData = await this.$services.master.UploadLogo({
        Base64String: val,
      });
      this.form.themeNavIcon = getData.url;
      this.$EventBus.$emit("hideLoading");
    },
    deleteThemeNavIcon() {
      this.form.themeNavIcon = "";
    },
    async onFileChange(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async () => {
        this.$EventBus.$emit("showLoading");
        const getData = await this.$services.master.UploadFont({
          Base64String: reader.result.replaceAll("data:font/ttf;base64,", ""),
        });
        this.form.themeFontUrl = getData.url;
        this.$EventBus.$emit("hideLoading");
      };
    },
    deleteFile() {
      this.form.themeFontUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.text-header {
  color: #092d53;
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
}

.footer {
  padding: 15px 0px;
  display: flex;
  justify-content: end;

  .btn {
    min-width: 100px;
  }
}

.front-preview-box {
  position: relative;
  height: 600px;
  border: 1px solid black;
  border-radius: 5px;
  max-width: 365px;
  display: flex;
  flex-direction: column;

  .navbar {
    height: 55px;
    padding: 16px;
    img {
      width: auto;
      height: 100%;
    }
  }

  .content {
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;

    .card {
      border-radius: 10px;
      .image {
        height: 200px;
        background-color: #e7e7e7;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      .card-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .card-content-title {
          font-size: 1.17em;
          font-weight: bold;
        }

        .info {
          display: flex;
          gap: 8px;
          align-items: center;
        }
      }
    }
  }

  .bottom-bar {
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -5px 6px rgba(0, 0, 0, 0.161);
    height: 70px;
    width: 100%;
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: space-around;
    height: 80px;

    .icon {
      display: flex;
      justify-content: center;
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;

      &:not(.active) {
        color: var(--secondary-color);
      }

      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
}
</style>
